import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { Observable } from "rxjs";
import { Token } from "../models/token.model";

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private baseUrl: string = `${environment.apiUrl}`
  private httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    })
  }

  constructor(private http$: HttpClient) {
  }

  login(username: string, password: string): Observable<Token> {
    const url: string = `${this.baseUrl}/token`
    let body = new URLSearchParams();
    body.set('username', username)
    body.set('password', password)
    return this.http$.post<Token>(url, body.toString(), this.httpOptions)
  }

  getProfile(): Observable<any> {
    const url: string = `${this.baseUrl}/users/me`;
    return this.http$.get<any>(url);
  }

  // getCurrentUser(): User | null {
  //   console.log('getCurrentUser triggered')
  //   const token = localStorage.getItem('jwt');
  //   if (token) {
  //     // Extract user from JWT token
  //     const decoded = jwtDecode(token);
  //
  //     return {
  //       ...UserInitState,
  //       ...decoded
  //     };
  //   }
  //   return null;
  // }
}
